import React from 'react';
import ThreeDotsLoader from './UI/ThreeDotsLoader';

const ScraperLoader = ({ text, progress }) => {
    const isEmailJob = progress?.success !== undefined;
    const percentage = progress && progress.total
        ? Math.round((progress.success / progress.total) * 100)
        : 0;

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md text-center">                
                <div className="mb-4">
                    <ThreeDotsLoader />
                </div>
                <p className="text-lg font-semibold">{text}</p>

                {progress && (
                    <div className="mt-4">
                        {isEmailJob ? (
                            <>
                                <p><strong>Status:</strong> {progress.status}</p>
                                <p><strong>Emails Sent:</strong> {progress.success} / {progress.total}</p>
                                <div className="w-full bg-gray-200 rounded-full h-4 mt-2">
                                    <div
                                        className="bg-blue-600 h-4 rounded-full"
                                        style={{ width: `${percentage}%` }}
                                    ></div>
                                </div>
                                <p className="text-sm mt-1">{percentage}% completed</p>
                            </>
                        ) : (
                            <>
                                <p><strong>URL:</strong> {progress.url}</p>
                                <p><strong>Status:</strong> {progress.status}</p>
                                <p><strong>Pages Scraped:</strong> {progress.pages_scraped} / {progress.total_pages}</p>
                                <div className="w-full bg-gray-200 rounded-full h-4 mt-2">
                                    <div
                                        className="bg-blue-600 h-4 rounded-full"
                                        style={{ width: `${Math.round((progress.pages_scraped / progress.total_pages) * 100)}%` }}
                                    ></div>
                                </div>
                                <p className="text-sm mt-1">{Math.round((progress.pages_scraped / progress.total_pages) * 100)}% completed</p>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ScraperLoader;